import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';


export type ContactDetails = {
  phone?: string;
  phoneFootnote?: string;
  cellphone?: string;
  cellphoneFootnote?: string;
  fax?: string;
  faxFootnote?: string;
  email?: string;
  website?: string;
}

enum FootnoteType {
  Phone,
  Cellphone,
  Fax,
}

interface FootnoteMetadata {
  index: number;
  duplicate: boolean;
}

@Component({
    selector: 'app-contact-details',
    imports: [],
    templateUrl: './contact-details.component.html',
    styleUrls: ['./contact-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent implements OnChanges {

  @Input() public contactDetails!: ContactDetails;

  protected footnoteType = FootnoteType;
  protected footnotes = new Map<FootnoteType, FootnoteMetadata>();

  public ngOnChanges(): void {
    this.calculateFootnotes();
  }

  private calculateFootnotes(): void {
    this.footnotes.clear();

    const { phoneFootnote, cellphoneFootnote, faxFootnote } = this.contactDetails;

    if (phoneFootnote) {
      this.footnotes.set(FootnoteType.Phone, { index: 1, duplicate: false });
    }

    if (cellphoneFootnote) {
      if (!phoneFootnote) {
        this.footnotes.set(FootnoteType.Cellphone, { index: 1, duplicate: false });
      } else if (cellphoneFootnote === phoneFootnote) {
        this.footnotes.set(FootnoteType.Cellphone, { index: 1, duplicate: true });
      } else {
        this.footnotes.set(FootnoteType.Cellphone, { index: 2, duplicate: false });
      }
    }

    if (faxFootnote) {
      if (faxFootnote === cellphoneFootnote) {
        const footnoteIndex = this.footnotes.get(FootnoteType.Cellphone)?.index || 1;
        this.footnotes.set(FootnoteType.Fax, { index: footnoteIndex, duplicate: true });
      } else if (faxFootnote === phoneFootnote) {
        this.footnotes.set(FootnoteType.Fax, { index: 1, duplicate: true });
      } else if (!phoneFootnote && !cellphoneFootnote) {
        this.footnotes.set(FootnoteType.Fax, { index: 1, duplicate: false });
      } else if (cellphoneFootnote === phoneFootnote) {
        this.footnotes.set(FootnoteType.Fax, { index: 2, duplicate: false });
      } else if (!phoneFootnote) {
        this.footnotes.set(FootnoteType.Fax, { index: 2, duplicate: false });
      } else {
        this.footnotes.set(FootnoteType.Fax, { index: 3, duplicate: false });
      }
    }
  }

  protected hasFootnotes(): boolean {
    return (
      this.contactDetails.phoneFootnote ||
      this.contactDetails.cellphoneFootnote ||
      this.contactDetails.faxFootnote
    ) !== undefined;
  }

}
